/* eslint-disable
    func-names,
    max-len,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const co = require('co');

const deps = [
  require('angular-ui-router'),
  require('./form').name,
  require('page/web/clientOverview').name,
];

module.exports = angular
  .module('bench.app.mainapp.details.overview', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.details.overview', {
      url: '/overview',
      resolve: {
        _collections(
          $q,
          $stateParams,
          LedgerCollection,
          LedgerWithTransactionsCollection,
          AddOnCollection,
          CategorizerRuleCollection,
          LedgerCategoryCollection,
        ) {
          const { clientId } = $stateParams;

          const ledgers = new LedgerCollection(clientId);
          const ledgersWithTransactions = new LedgerWithTransactionsCollection(clientId);
          const addOns = new AddOnCollection(clientId);
          const rules = new CategorizerRuleCollection(clientId);
          const ledgerCategories = new LedgerCategoryCollection();

          return $q.all([
            ledgers.$promise,
            ledgersWithTransactions.$promise,
            addOns.$promise,
            rules.$promise,
            ledgerCategories.$promise,
          ]);
        },
      },
      views: {
        '': {
          controller($stateParams) {
            this.clientId = $stateParams.clientId;

            return this;
          },
          controllerAs: 'vm',
          template: `\
<bl-client-overview
  client-id="vm.clientId">
</bl-client-overview>\
`,
        },
        'navbar-action': {
          controller($state, $scope, blConstants) {
            this.keyCode = blConstants.KEY_CODE;
            this.create = () => $state.go('bench.details.overview.form.new');

            $scope.$on('blKeydown', (onEvent, keypressEvent) => {
              const isMac = () => navigator.platform.toLowerCase().indexOf('mac') !== -1;
              const isCtrlKeyDown = function () {
                if (isMac()) {
                  return keypressEvent.metaKey;
                }
                return keypressEvent.ctrlKey;
              };
              const { keyCode } = keypressEvent;

              if (keyCode === this.keyCode.L && isCtrlKeyDown()) {
                return this.create();
              }
            });

            return this;
          },
          controllerAs: 'vm',
          template: `\
<button
  ng-click="vm.create()"
  class="bl-button nav-button">
  <span class="bl-icon bl-icon-create-new"></span>
  Create New
  <span class="hotkey">⌘L</span>
</button>\
`,
        },
      },
    }),
  );
